import { EmailCommunicationsPage } from '@features/communications/components/EmailCommunicationsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/communication/email')({
  component: RouteComponent,
})

function RouteComponent() {
  return <EmailCommunicationsPage />
}
